export default __webpack_public_path__ + "static/035-b97f9c22df65e03f99d40dd4bc098b5c.png";